// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // ApiUrl : 'http://13.201.100.244/api/'
  ApiUrl : 'https://apimbp.knackbe.in/api/'
  //  ApiUrl : 'http://apimbp.knackbe.in/api/'
  //  ApiUrl: 'http://localhost:59864/api/'
  // ApiUrl: 'http://betambpapi.knackbetechnologies.in/api/'
//   ApiUrl: 'https://api.mbplans.in/mbp/api/'
   
};


/*P
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
